// 루트의 후반 교체 아이템(lateGameItems)이 쓰는 "오브젝트" 재료를 센다 (순수 함수).
// 후반 교체 아이템(전설/신화)마다 materialCode가 있는데, 이것이 맵 오브젝트에서 얻는 재료다.
// 재료 코드는 API에 이름 없이 숫자로만 오므로 아래 표로 이름을 붙인다(L10N 이름 API가 없어 하드코딩).
// 이름은 dak.gg 아이템 아이콘(ItemIcon_{코드})을 보고 확인했다.

export const OBJECTS = [
  { key: 'meteor', name: '운석', code: 401209 },
  { key: 'tree', name: '생명의 나무', code: 401208 },
  { key: 'mithril', name: '미스릴', code: 401304 },
  { key: 'force', name: '포스 코어', code: 401403 },
  { key: 'blood', name: '혈액팩', code: 401401 },
];

// 다섯 오브젝트가 아닌 재료는 세지 않는다. 예: -진홍/-새벽 변형 신화 장비가 쓰는 401405(붉은 결정), 401406(푸른 결정)은 오브젝트가 아니다(사용자 확인).
const OBJECT_CODES = new Set(OBJECTS.map((o) => o.code));

/**
 * lateGameItems: { "0": [{ code, name, grade, materialCode }], "1": [...], ... } — 후반 교체 "선택지" 묶음들.
 * 묶음은 순서대로 쓰는 단계가 아니라 대안 선택지라(전설 5개 세트가 묶음마다 따로 나온다), 전부 합치면 장비 5칸보다 훨씬 많이 부풀어
 * 첫 번째 묶음(번호가 가장 작은 묶음, 슬롯당 1개의 기본 빌드)만 센다. 전설/신화 등급 구분 없이 같은 규칙이고, 같은 아이템(code)은 한 번만 센다.
 * 다섯 오브젝트가 아닌 재료는 세지 않는다.
 * 돌려주는 값: { byCode: { 재료코드: 개수 }, items: { 재료코드: [쓰는 아이템 이름] } }
 */
export function countObjects(lateGameItems) {
  const result = { byCode: {}, items: {} };
  if (!lateGameItems) {
    return result;
  }
  const keys = Object.keys(lateGameItems).sort((a, b) => Number(a) - Number(b));
  const seen = new Set();
  (keys.length ? lateGameItems[keys[0]] || [] : []).forEach((item) => {
    if (!item.materialCode || seen.has(item.code)) {
      return;
    }
    seen.add(item.code);
    if (OBJECT_CODES.has(item.materialCode)) {
      result.byCode[item.materialCode] = (result.byCode[item.materialCode] || 0) + 1;
      (result.items[item.materialCode] = result.items[item.materialCode] || []).push(item.name);
    }
  });
  return result;
}

/**
 * entries: [{ teamIndex, characterName, weaponName, area, objectCounts }] — objectCounts는 countObjects 결과(없으면 조회 중이거나, unavailable이 true면 알 수 없음).
 * 팀별 합계 teams: [{ teamIndex, byCode, known(합친 팀원 수), unavailable(알 수 없는 팀원 수), pending(조회 중인 팀원 수), members }]와 전체 합계 total을 돌려준다.
 */
export function tallyTeamObjects(entries) {
  const byTeam = new Map();
  const total = { byCode: {} };
  const add = (target, counts) => {
    Object.entries(counts.byCode).forEach(([code, n]) => {
      target.byCode[code] = (target.byCode[code] || 0) + n;
    });
  };
  entries.forEach((entry) => {
    if (!byTeam.has(entry.teamIndex)) {
      byTeam.set(entry.teamIndex, { teamIndex: entry.teamIndex, byCode: {}, known: 0, unavailable: 0, pending: 0, members: [] });
    }
    const team = byTeam.get(entry.teamIndex);
    team.members.push(entry);
    if (!entry.objectCounts) {
      // unavailable: 루트 통계가 없거나 조회에 실패해 알 수 없음, 그 외는 아직 조회 중
      team[entry.unavailable ? 'unavailable' : 'pending'] += 1;
      return;
    }
    team.known += 1;
    add(team, entry.objectCounts);
    add(total, entry.objectCounts);
  });
  return { teams: [...byTeam.values()], total };
}
